import { StatusInfoCircle } from '@energy-retailer/icons';
import { twMerge } from 'tailwind-merge';

import { Icon } from '@/components/icon';

import type { InfoBoxProps } from './alert.types';

const InfoBox = ({ icon, children, className }: InfoBoxProps) => {
  return (
    <div
      className={twMerge(
        'flex gap-b rounded-rad-a border border-pink p-b',
        className
      )}
      role="alert"
    >
      <div>
        <Icon
          className="h-icon-xs w-icon-xs text-pink"
          icon={
            icon ? (
              icon
            ) : (
              <StatusInfoCircle data-testid="StatusInfoCircle icon" />
            )
          }
        />
      </div>
      <div className="flex items-center justify-center">{children}</div>
    </div>
  );
};

export default InfoBox;
